/* Voltkart: save the buyer's GSTIN to the cart attribute "GST Number" as soon as it's typed,
   from any [data-vk-gst] input (cart page box or add-to-cart pop-up). Keeps all GST boxes in sync. */
(function () {
  var RX = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z][1-9A-Z]Z[0-9A-Z]$/;
  var timer = null;

  function msgFor(input) {
    var box = input.closest('.vk-gst-mini, .voltkart-gst-card');
    return box ? box.querySelector('.vk-gst-mini__msg, .vk-gst-msg') : null;
  }

  function show(input, text, cls) {
    var m = msgFor(input);
    if (!m) return;
    m.textContent = text;
    m.classList.remove('is-ok', 'is-bad');
    if (cls) m.classList.add(cls);
  }

  function save(value, input) {
    fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: { 'GST Number': value } })
    }).then(function (r) {
      if (!r.ok) throw new Error(r.status);
      if (value) show(input, RX.test(value) ? 'Saved. We will use it for your GST invoice.' : 'Saved. Please check the number: a GSTIN has 15 characters, e.g. 07AAACC4175D1ZY.', RX.test(value) ? 'is-ok' : 'is-bad');
      else show(input, '', null);
    }).catch(function () {
      show(input, 'Could not save. You can also add it in the Company field at checkout.', 'is-bad');
    });
  }

  document.addEventListener('input', function (e) {
    var input = e.target;
    if (!input.matches || !input.matches('[data-vk-gst]')) return;
    var v = input.value.toUpperCase().replace(/\s+/g, '');
    if (v !== input.value) input.value = v;
    document.querySelectorAll('[data-vk-gst]').forEach(function (other) { if (other !== input) other.value = v; });
    clearTimeout(timer);
    timer = setTimeout(function () { save(v, input); }, 600);
  });
})();
